import { HostElement } from "@stencil/core/internal";
import { MENU_LOCALIZATION } from "../constants/localization";
import { getLocalizationLocale } from "./localization-helper";

/**
 *
 * @param hostElement The host element of the component where the context menu is added
 * @param isMenuVisible whether the context menu is visible
 * @param ariaLabel optional label
 * @returns Properties to be used on the opening component of a context menu
 */
export const getContextMenuProps = (hostElement: HostElement, isMenuVisible: boolean, ariaLabel?: string) => {
  const locale = getLocalizationLocale(hostElement);
  return {
    role: "menu",
    "aria-label": ariaLabel ?? MENU_LOCALIZATION[locale].defaultAriaLabel,
    "aria-haspopup": "true",
    "aria-expanded": isMenuVisible ? "true" : "false"
  };
};
